import { InjectionToken } from '@angular/core';

export interface CartConfig {
  apiUrl: string;
}

export const CART_CONFIG = new InjectionToken<CartConfig>('CartConfig');
